import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import Router from "./app/router";
import { Navbar, Footer } from "./components/layout";
import { useInit } from "./hooks/useInit";
import { Loader, ToastFmc } from "./components/common";
import { WhatsAppButton, ShoppingCart } from "./components/ui";
export const App = () => {
    const { loader } = useInit();
    return (_jsxs("div", { className: "fm-container", children: [_jsx(Loader, { show: loader }), _jsx(Navbar, {}), _jsx(Suspense, { fallback: _jsx(Loader, { show: true }), children: _jsx(Router, {}) }), _jsx(Footer, {}), _jsx(ToastFmc, {}), _jsx(WhatsAppButton, {}), _jsx(ShoppingCart, {})] }));
};
